// eslint-disable-next-line import/no-named-default
import { default as AppLoader } from './CalendarLoader';

const APP_SELECTOR = '[data-component="calendar"]';

// Export for loader testing purposes
export default function init() {
    // Don't run on a non app page
    const appWrapper = document.querySelectorAll(APP_SELECTOR);
    if (appWrapper.length > 0) {
        // Only load ReactDOM from if its needed as its pretty large
        import(/* webpackChunkName: "ReactDOM" */ 'react-dom').then((ReactDOM) => {
            appWrapper.forEach((wrapper) => {
                const appConfig = JSON.parse(wrapper.dataset.configuration);
                const appLoader = new AppLoader(appConfig);
                ReactDOM.render(appLoader.getComponent(), wrapper);
            });
        });
    }
}
// Self invoke the function for production builds
init();
